import script from "./ProductManage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductManage.vue?vue&type=script&lang=ts&setup=true"

import "./ProductManage.vue?vue&type=style&index=0&id=69cf6e53&lang=css&scoped=true"
import "./ProductManage.vue?vue&type=style&index=1&id=69cf6e53&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69cf6e53"]])

export default __exports__